import { useModal } from 'react-modal-hook';
import { useTranslation } from 'react-i18next';

import { GetOrderQuery as GetOrder } from '__generated__/graphql';
import CopyLink from '../../../../common/Common/CopyLink';
import UI from '../../../../common/UI';
import useLocale from '../../../../common/useLocale';

type Order = GetOrder['order'];

interface UsePaymentLinkModalProps {
  order: Order;
}

const usePaymentLinkModal = ({ order }: UsePaymentLinkModalProps) => {
  const { formatCurrency } = useLocale();
  const { t } = useTranslation();

  const [openModal, closeModal] = useModal(() => (
    <UI.Modal close={closeModal}>
      <UI.H4 sc={{ mb: 2 }}>
        {t('payment_link')}
      </UI.H4>
      <UI.Paragraph>
        {t('payment_link_description', {
          amount: formatCurrency(order.remaining_amount),
        })}
      </UI.Paragraph>
      <UI.InputGroup>
        <UI.Input
          value={order.dashboard_url}
          readOnly
          onFocus={(event) => event.target.select()}
        />
      </UI.InputGroup>
      <CopyLink value={order.dashboard_url}>
        {t('copy')}
      </CopyLink>
    </UI.Modal>
  ), [order]);

  return [openModal, closeModal];
};

export default usePaymentLinkModal;
